import { useState } from "react";
import SettingSidebar from "./SettingSidebar";
import SettingGroup from "./SettingGroup";

const SettingsIndex = ({}) => {
  const menus = [
    { label: "Groupes", icon: null },
  ];

  const sessionStorageMenuActive = sessionStorage.getItem("settingMenuActive");
  const lastMenuActive = sessionStorageMenuActive
    ? JSON.parse(sessionStorage.getItem("settingMenuActive"))
    : { ...menus[0], value: 0 };

  const [menuActive, setMenuActive] = useState(lastMenuActive);

  return (
    <div className="">
      <SettingSidebar
        menus={menus} menuActive={menuActive} setMenuActive={setMenuActive}
      />
      <div className={`page-container open settings`}>
        {menuActive.value === 0 && <SettingGroup />}
      </div>
    </div>
  );
};

export default SettingsIndex;
